"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isDefined(value) {
    return value !== undefined && value !== null;
}
exports.isDefined = isDefined;
function isEmpty(value) {
    return !isDefined(value) || value === '';
}
exports.isEmpty = isEmpty;
function isString(value) {
    return typeof value === 'string' || value instanceof String;
}
exports.isString = isString;
/**
 * Takes an optionally nested textobject structure and convert to a flat
 * structure. Nested keys are joined with a dot ".". Deep nesting is supported.
 *
 * Given the following:
 * {
 *   "foo": {
 *     "bar": "text"
 *   }
 * }
 *
 * It would produce the following output:
 * {
 *   "foo.bar": "text"
 * }
 *
 * If the src object is already flat the output will be the same.
 *
 * @param src - Source data
 * @param destination - Destination to write temporary result to.
 * @param prefix - If set this is prefixed to all keys.
 */
function flatten(src, destination, prefix) {
    if (prefix === void 0) { prefix = ''; }
    destination = destination || {};
    return Object.entries(src).reduce(function (result, _a) {
        var key = _a[0], data = _a[1];
        var nestedKey = "" + prefix + key;
        if (typeof data === 'string') {
            result[nestedKey] = data;
        }
        else {
            flatten(data, result, nestedKey + ".");
        }
        return result;
    }, destination);
}
exports.flatten = flatten;
/**
 * Takes a string containing only numbers and checks that the checksum is correct
 * according to the Luhn Algorithm.
 *
 * @param inputString - A string containing only numbers
 */
function testLuhnChecksum(inputString) {
    var sum = 0;
    if (/^[0-9]+$/.test(inputString) === false) {
        throw new Error('Luhn Checksum test only works on strings containing numbers');
    }
    inputString
        .split('')
        .reverse()
        .forEach(function (numChar, index) {
        var digit = parseInt(numChar, 10) * ((index + 1) % 2 === 0 ? 2 : 1);
        sum += digit >= 10 ? digit - 9 : digit;
    });
    return sum % 10 === 0;
}
exports.testLuhnChecksum = testLuhnChecksum;
/**
 * Executes a function when it stops being invoked for n seconds. Usually used together with resize,
 * scroll and keyup/keydown-events to improve application's performance.
 *
 * Example:
 *
 *    window.addEventListener(
 *        'resize',
 *        debounce(computationalHeavyFunction, 1000),
 *    );
 *
 * This will call the computationalHeavyFunction once if the resize-event hasn't been sent for 1000 ms.
 *
 * Example with immediate-flag:
 *
 *    window.addEventListener(
 *        'resize',
 *        debounce(computationalHeavyFunction, 1000, true),
 *    );
 *
 * This will call the computationalHeavyFunction once BEFORE the resize-event has finished,
 * and thereafter will not be able to be called again until the timeout has finished
 *
 * @param func Function to be debounced.
 * @param delay Function execution threshold in milliseconds.
 * @param immediate Whether the function should be called at the beginning of the delay (Before the timeout) instead of the end.
 * Default is false.
 */
function debounce(func, delay, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timeout = null;
    return function functionToExecute() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias, consistent-this
        var context = this;
        var timedOutFunction = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        if (timeout !== null) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(timedOutFunction, delay);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
exports.debounce = debounce;
//# sourceMappingURL=Utils.js.map